import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  ReferralTransfer,
  ReferralTransferPayload,
} from "@project/types/referral-transfer";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/referral-transfers`;
const SILENT: RequestConfig = { showNotification: false };

class ReferralTransferService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<ReferralTransfer>> => {
    return fetchListPage<ReferralTransfer>(`${BASE}/`, query);
  };

  get = async (id: number): Promise<ReferralTransfer | undefined> => {
    const data = await get<ApiItemResponse<ReferralTransfer> | ReferralTransfer>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (
    payload: ReferralTransferPayload
  ): Promise<ReferralTransfer | undefined> => {
    const data = await post<
      ApiItemResponse<ReferralTransfer> | ReferralTransfer,
      ReferralTransferPayload
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  update = async (
    id: number,
    payload: Partial<ReferralTransferPayload>
  ): Promise<ReferralTransfer | undefined> => {
    const data = await patch<
      ApiItemResponse<ReferralTransfer> | ReferralTransfer,
      Partial<ReferralTransferPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const referralTransferService = new ReferralTransferService();
